export default {"src":"/_next/static/media/SS-point.d3980de4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};